import * as React from "react";
const SvgIcColumn = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M9 4V20M15 4V20M4 4H20V20H4V4Z", stroke: "currentColor", strokeWidth: 2, strokeLinejoin: "round" }));
export default SvgIcColumn;
